import React from "react";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const EquipmentExpandLink = ({ id, action }) => {
  const { navigateToEquipmentDetail } = useSmartNavigate();

  const handleClick = (e) => {
    e.stopPropagation(); // Prevent row click from triggering
    if (action) {
      navigateToEquipmentDetail(id);
    }
  };

  return (
    <a onClick={handleClick}>
      <i className="fas fa-expand-arrows-alt text-lg"></i>
    </a>
  );
};

export default EquipmentExpandLink;


